import { I18n } from "i18n-js";
import strEn from "./translations_en.json";
import strZh from "./translations_zh.json";

const i18n = new I18n();

i18n.store(strEn);
i18n.store(strZh);

i18n.locale = document.documentElement.lang === 'zh'? 'zh-CN' : 'en';
i18n.missingBehavior = "guess";
i18n.enableFallback = true;

export default i18n
